const { MacroSourceContainer, SourceTitle, SourceLink } = require('./AgentAssistSource.styles');

const AgentAssistSource = ({ sources }) => {
  const createSourceLink = (documentationSource, sourceTitle) => (
    <SourceLink data-testid={documentationSource} href={documentationSource} target="_blank" rel="noreferrer no opener">
      {sourceTitle}
      <img alt="open-source" src="/images/new-designs/arrow-up-right.svg" />
    </SourceLink>
  );

  return (
    <MacroSourceContainer>
      <SourceTitle>Source Documentation:</SourceTitle>
      {createSourceLink(sources, 'Link to Article')}
    </MacroSourceContainer>
  );
};

export default AgentAssistSource;
